import { Box, styled, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SubscriptionCard } from '../../components/SubscriptionCard';
import { UserContext } from '../../providers/UserProvider';
import {
    StyledGreenButton,
    StyledMediumTypography,
    StyledRowBox
} from '../../theme/StyledElements';

const StyledBox = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '60px',
    alignItems: 'center'
}));

const StyledSummary = styled(Typography)(() => ({
    color: '#134C03',
    textAlign: 'left',
    marginBottom: '10px',
    fontWeight: 'normal',
    margin: '20px 0px 20px -590px'
}));

const StyledSubheading = styled(Typography)(() => ({
    color: '#134C03',
    width: '250px',
    fontWeight: 'normal',
    marginRight: '55px'
}));

export function Summary(): React.ReactElement {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const user = useContext(UserContext);

    return (
        <StyledBox>
            <StyledSummary variant="h2">{t('summary')}</StyledSummary>
            <StyledRowBox>
                <Box>
                    <StyledSubheading variant="h3">
                        {t('accountCreated', { firstName: user?.prenom, lastName: user?.nom })}
                    </StyledSubheading>
                    <StyledGreenButton
                        type="button"
                        onClick={(): void => {
                            navigate('/dashboard');
                        }}>
                        <StyledMediumTypography variant="caption" color="#FFFFFF">
                            {t('accessAmo')}
                        </StyledMediumTypography>
                    </StyledGreenButton>
                </Box>
                <SubscriptionCard />
            </StyledRowBox>
        </StyledBox>
    );
}
